import { useState } from 'react';

export default function Recherche404() {
  const [query, setQuery] = useState('');

  const handleSearch = () => {
    if (!query.trim()) return;
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(`/?search=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <section className="py-14 md:py-20 bg-soft-gray">
      <div className="max-w-xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-2xl font-bold text-slate-primary mb-2">
          Que cherchiez-vous ?
        </h2>
        <p className="text-slate-primary/60 text-sm mb-6">
          Saisissez un mot-clé et nous vous redirigerons vers la bonne page.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSearch();
            }}
            placeholder="Ex: réfection, bardeau, fuite..."
            className="flex-1 px-4 py-3 rounded-md border border-soft-dark bg-white text-sm text-slate-primary placeholder:text-slate-primary/40 focus:outline-none focus:ring-2 focus:ring-copper/50"
          />
          <button
            onClick={handleSearch}
            className="bg-copper hover:bg-copper-dark text-white font-semibold px-6 py-3 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line mr-2" />
            Rechercher
          </button>
        </div>
      </div>
    </section>
  );
}